// THIS CODE IS GENERATED. DO NOT MODIFY
/* istanbul ignore next */
(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csContactCalculateDisplayAs', ['bmHttpUtils', 'bluemoon.components.session']).service('csContactCalculateDisplayAs',
        ['$http', 'bmHttpUtils',
        function($http, bmHttpUtils) {
            return {
                calculateDisplayAs: function(params, suppressErrors) {
                    var url = '/api/core/v1/contacts/calculate-display-as';
                    var strippedData = bmHttpUtils.getStrippedObject(params['contactDisplayAsV1Dto'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['contactDisplayAsV1Dto'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                }

            };
        }]);
}(window.angular));
